export default "__VITE_ASSET__BxiKG2Q4__"